import React from "react";
import { Button } from "../../../OldFront/Simple/ButtonComponent/Button";
import Modal from "../../../OldFront/Complex/ModalComponent/Modal";
import Heading3 from "../../../OldFront/Simple/Heading3Component/Heading3";
import BodyText from "../../../OldFront/Simple/BodyTextComponent/BodyText";
import InputText from "../../../OldFront/Simple/Text/InputText";
import InputEmail from "../../../OldFront/Simple/Email/InputEmail";
import InputPhoneNumber from "../../../OldFront/Simple/PhoneNumber/InputPhoneNumber";

export type TListingInfoRequestFormProps = {
    address: string;
    firstName: string;
    lastName: string;
    contactEmail: string;
    contactPhoneNumber: string;
    submitting: boolean;
    submitted: boolean;
    failed: boolean;
    isOpen: boolean;
    onOpen: () => void;
    onClose: () => void;
    onFirstNameChange: (value: string) => void;
    onLastNameChange: (value: string) => void;
    onEmailChange: (value: string) => void;
    onPhoneChange: (value: string) => void;
    onSubmit: () => void;
};

export const isComplete = (props: Pick<TListingInfoRequestFormProps, "firstName" | "lastName" | "contactEmail" | "contactPhoneNumber">): boolean =>
    props.firstName.trim() !== ""
    && props.lastName.trim() !== ""
    && props.contactEmail.trim() !== ""
    && props.contactPhoneNumber.trim() !== "";

export const ListingInfoRequestForm = (props: TListingInfoRequestFormProps): JSX.Element =>
    <>
        <Button
            label="Request more info"
            type="otter"
            disabled={false}
            onClick={props.onOpen}
            fullWidth={true}
        />

        {props.isOpen &&
            <Modal fullScreenOnMobile={true} onCloseClicked={props.onClose}>
                {props.submitted
                    ? <div className="listing-info-request">
                        <Heading3 text="On its way" />
                        <BodyText type="normal">
                            We have sent you everything we hold on this property, and someone will call you.
                        </BodyText>
                    </div>
                    : <div className="listing-info-request">
                        <Heading3 text="Request more info" />
                        <BodyText type="normal">
                            <span className="listing-info-request__address">{`About ${props.address}`}</span>
                        </BodyText>
                        <BodyText type="normal">
                            We will email you the documents we hold and give you a call.
                        </BodyText>

                        <div className="listing-info-request__fields">
                            <InputText
                                name="firstName"
                                className=""
                                placeholder="First name"
                                value={props.firstName}
                                onChange={props.onFirstNameChange}
                                onPressEnterKey={() => undefined}
                            />
                            <InputText
                                name="lastName"
                                className=""
                                placeholder="Last name"
                                value={props.lastName}
                                onChange={props.onLastNameChange}
                                onPressEnterKey={() => undefined}
                            />
                            <InputEmail
                                name="contactEmail"
                                className=""
                                placeholder="lindsayandsam@ouremail.com"
                                value={props.contactEmail}
                                onChange={props.onEmailChange}
                                onPressEnterKey={() => undefined}
                            />
                            <InputPhoneNumber
                                name="contactPhoneNumber"
                                className=""
                                placeholder="07000111222"
                                value={props.contactPhoneNumber}
                                onChange={props.onPhoneChange}
                                onPressEnterKey={() => undefined}
                            />
                        </div>

                        {props.failed &&
                            <div className="listing-info-request__error">
                                That did not send. Please try again, or call us on 0808 196 5200.
                            </div>
                        }

                        <Button
                            label={props.submitting ? "Sending…" : "Send me the details"}
                            type="rooster"
                            disabled={props.submitting || !isComplete(props)}
                            onClick={props.onSubmit}
                            fullWidth={true}
                        />
                    </div>
                }
            </Modal>
        }
    </>;
